<template>
    <div class="row">
        <div class="col-12">
            <p class="d-flex align-items-center">
                <span class="icon icon-hands-free font-size-24" aria-hidden="true" />
                <span class="ms-1 fw-bold" v-html="text" />
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: "FreeHands",
    props: {
        text: {
            type: String,
            required: true
        }
    }
}
</script>
